module.exports = __webpack_public_path__ + "static/media/speed.80cca03a.png";